import React from "react";
import SvgIconBase from "./SvgIconBase";
import { SvgIconProps } from "@mui/material/SvgIcon";

export const ActivitiesIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase {...props}>
<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M168.46-730v-60h623.08v60H168.46ZM170-170v-240h-44.61v-60l43.07-200h623.08l43.07 200v60H790v240h-60v-240H550v240H170Zm60-60h260v-180H230v180Zm-43.39-240h586.78-586.78Zm0 0h586.78l-30.54-140h-525.7l-30.54 140Z"/></svg>  </SvgIconBase>
);
